import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppointmentTitle = _resolveComponent("AppointmentTitle")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['px-12', _ctx.contentColumnClass])
  }, [
    _createVNode(_component_MainContent, { paddingClass: "py-6 px-6" }, {
      default: _withCtx(() => [
        (_ctx.showAppointmentTitle)
          ? (_openBlock(), _createBlock(_component_AppointmentTitle, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_router_view)
        ])
      ]),
      _: 1
    })
  ], 2))
}